import styled from 'styled-components/macro';

const MaterialCardStyled = styled.div`
  position: relative;
  width: 800px;
  margin: 0 auto 10px;
`;

export default MaterialCardStyled;
